import { isBotId } from '@game/shared';
import { cn } from '../lib/cn.js';
import { useGameStore } from '../game/store.js';

export const Scoreboard = () => {
  const rows = useGameStore((state) => state.scoreboard);

  return (
    <div className="absolute left-1/2 top-1/2 w-[min(620px,90vw)] -translate-x-1/2 -translate-y-1/2 rounded-xl border border-white/10 bg-surface-900/92 p-6 backdrop-blur-md">
      <div className="mb-3 grid grid-cols-[1fr_4rem_4rem_4rem] px-2 text-[11px] uppercase tracking-[0.2em] text-ink-muted">
        <span>Player</span>
        <span className="text-right">K</span>
        <span className="text-right">D</span>
        <span className="text-right">K/D</span>
      </div>

      {rows.length === 0 ? (
        <p className="px-2 py-4 text-sm text-ink-muted">Waiting for players…</p>
      ) : (
        rows.map((row) => (
          <div
            key={row.id}
            className={cn(
              'grid grid-cols-[1fr_4rem_4rem_4rem] rounded px-2 py-1.5 text-sm',
              row.isSelf && 'bg-white/8 font-semibold',
            )}
          >
            <span className={row.team === 0 ? 'text-team-blue' : 'text-team-red'}>
              {row.name}
              {/* Bots are always disclosed — the tag, not the name, is the marker. */}
              {isBotId(row.id) && (
                <span className="ml-2 rounded border border-white/20 bg-white/10 px-1 text-[10px] uppercase tracking-wider text-ink-muted">
                  bot
                </span>
              )}
            </span>
            <span className="text-right tabular">{row.kills}</span>
            <span className="text-right tabular">{row.deaths}</span>
            <span className="text-right tabular text-ink-muted">
              {(row.kills / Math.max(1, row.deaths)).toFixed(2)}
            </span>
          </div>
        ))
      )}
    </div>
  );
};
